// Community stats per condition
export const COMMUNITIES = {
  Lupus: { size: 2340, monthlyActive: 892 },
  Narcolepsy: { size: 1280, monthlyActive: 510 },
  'Polycythemia Vera': { size: 870, monthlyActive: 340 },
  _default: { size: 1500, monthlyActive: 600 }
};

// Multiple questions per condition — rotated after each answer
export const QUESTIONS = {
  Lupus: [
    { id: 'lupus-q1', question: 'When you were first diagnosed with lupus, what information did you seek?' },
    { id: 'lupus-q2', question: 'What do you wish your doctor had told you earlier about managing lupus?' },
    { id: 'lupus-q3', question: 'How has lupus changed the way you think about planning your future?' },
    { id: 'lupus-q4', question: 'What does a "good day" look like for you living with lupus?' },
  ],
  Narcolepsy: [
    { id: 'narcolepsy-q1', question: 'When you were first diagnosed with narcolepsy, what did you most need other people to understand?' },
    { id: 'narcolepsy-q2', question: 'What part of living with narcolepsy do most people never see?' },
    { id: 'narcolepsy-q3', question: 'How do you manage narcolepsy symptoms at work or school?' },
    { id: 'narcolepsy-q4', question: 'What medication or treatment has made the biggest difference for you?' },
  ],
  'Polycythemia Vera': [
    { id: 'pv-q1', question: 'When you were first diagnosed with PV, what surprised you most about living with it?' },
    { id: 'pv-q2', question: 'How do you explain polycythemia vera to someone who has never heard of it?' },
    { id: 'pv-q3', question: 'What side effect or symptom caught you most off guard?' },
    { id: 'pv-q4', question: 'How has your relationship with your hematologist evolved over time?' },
  ],
  _default: [
    { id: 'general-q1', question: 'When you were first diagnosed, what was the first thing you wanted to know?' },
    { id: 'general-q2', question: 'What advice would you give to someone who just received your diagnosis?' },
    { id: 'general-q3', question: 'What has been the hardest part of your treatment journey so far?' },
    { id: 'general-q4', question: 'How has your condition changed the way you interact with the healthcare system?' },
  ]
};
